<template>
  <v-dialog v-model="isOpenDialog" width="620px" class="color">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title class="text-uppercase">Chi tiết bảng lương</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text id="element-to-convert">
        <TeacherInfo />
        <BillReport />
        <div class="summary_wrap" v-if="period.status !== 'created'">
          <div class="summary_final">
            <p>Tổng kết cuối:</p>
            <span>{{ period.updatedAt | ddmmyyyyhhmm }}</span>
          </div>
          <div class="summary_people">
            <p>Người tổng kết:</p>
            <span>{{ get(period, 'generatedBy.name', '') }}</span>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mt-5">
        <v-btn depressed color="primary" class="px-6 ml-2 mt-n4 mb-2 white--text text-uppercase" @click="onSummary">
          TỔNG KẾT LẠI
        </v-btn>
        <v-spacer />
        <v-btn
          depressed
          color="primary"
          class="px-6 mr-2 mt-n4 mb-2 white--text d-none text-uppercase"
          @click="exportPdf"
        >
          XUẤT FILE PDF
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import html2pdf from 'html2pdf.js'
import BillReport from './BillReport.vue'
import TeacherInfo from './TeacherInfo.vue'
import { mapActions, mapGetters } from 'vuex'
import get from 'lodash-es/get'
export default {
  components: {
    TeacherInfo,
    BillReport
  },
  data() {
    return {
      isOpenDialog: false,
      loading: false,
      get
    }
  },
  computed: {
    ...mapGetters({
      period: 'salaryPeriod/period',
      report: 'salaryReport/report'
    })
  },
  methods: {
    ...mapActions('salaryReport', ['summaryOne', 'fetchOne']),
    async openDialog() {
      await this.fetchOne(this.report.id)
      this.isOpenDialog = true
    },
    cancel() {
      this.isOpenDialog = false
    },
    exportPdf() {
      const convertFullDate = this.$options.filters.convertFullDate(this.period.title)
      const name = get(this.report, 'teacher.name')
      const phone = get(this.report, 'teacher.phone')
      html2pdf(document.getElementById('element-to-convert'), {
        filename: `BL ${name}_${phone}_${convertFullDate}.pdf`
      })
    },
    onSummary() {
      this.$dialog.confirm({
        title: 'Xác nhận tổng kết lại?',
        text:
          'Các thông tin cũ trong bảng lương có thể bị thay đổi và<br/>không thể hoàn tác. Bạn có chắc chắn muốn tổng kết lại bảng lương cho giáo viên này',
        cancelText: 'Hủy',
        okText: 'Xác nhận',
        done: async () => {
          try {
            this.$loading.active = true
            await this.summaryOne({ teacherId: this.report.teacher.id, periodId: this.period.id })
            this.$loading.active = false
            this.$alert.success('Đã tổng kết lại thành công!')
          } catch (e) {
            this.$loading.active = false
            let msg = {
              title: 'Lỗi thao tác',
              description: 'Hệ thống đang thực hiện tổng kết. Vui lòng chờ.'
            }
            if (e === 'Connection fail') {
              msg = {
                title: 'Lỗi kết nối',
                description: 'Không thể thực hiện tổng kết. Vui lòng thử lại.'
              }
            }
            this.$alert.error({ title: msg.title, description: msg.description })
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
#element-to-convert {
  font-family: 'Roboto';
}

.margin {
  margin: 10px 0;
}

.summary_wrap > .summary_final,
.summary_people {
  display: flex;
  margin: 12px 12px 12px 20px;
}

.summary_wrap > .summary_final p,
.summary_people p {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin: 1px 8px 0 0;
}

.total_money {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
}

.total_money h3,
.total_money span {
  color: #fd6b6b;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
</style>
